import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import classNames from 'classnames'
import immutable from 'immutable'
import Recaptcha from 'react-recaptcha'

import {LunaModal} from '../widgets/lunamodal.component'

export class TeamBlock extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showModal: false,
            statusModal: null,
            showFullTeam: false,
            firstName: null,
            lastName: null,
            email: null,
            recaptcha: null,
            isModalLoaderActive: false,
        }

        _.bindAll(this, 'showModal', 'onModalHide', 'toggleFullTeam', 'onSubmit', 'updateValue', 'requireRecaptcha', 'onRecaptchaVerified')
    }

    showModal() {
        this.setState({
            showModal: true,
            statusModal: null,
        })
    }

    onModalHide() {
        this.setState({
            showModal: false,
        })
    }

    updateValue(key, value) {
        const update = {}
        update[key] = value
        this.setState(update)
    }

    requireRecaptcha() {
        return this.props.travelers.filter((traveler) => traveler.get('email') !== 'trips@lunamoons.com').size >= 5
    }

    onRecaptchaVerified(token) {
        this.updateValue('recaptcha', token)
    }

    renderRecaptcha() {
        if (!this.requireRecaptcha()) {
            return null
        }

        return (
            <div className="text-center">
                <Recaptcha sitekey="6Ldh2kkUAAAAAKELRRFh77o5y_vXnqrb_lAJFZ1l" verifyCallback={this.onRecaptchaVerified}/>
            </div>
        )
    }

    renderSubmit() {
        return <button type="submit" className="btn btn-medium btn-blue btn-submit" disabled={this.requireRecaptcha() && !this.state.recaptcha ? 'disabled' : null}>Send Invite</button>
    }

    modalContent() {
        return (
            <div className="modal-content">
                <div className={classNames('modal-loader-mask', {active: this.state.isModalLoaderActive})}>
                    <div className="modal-mask"/>
                    <i className="icon-settings spinner" aria-hidden="true"/>
                </div>
                <h2>Invite a Traveler!</h2>
                <div>
                    Send an invite to someone to help craft your trip.
                </div>
                <form onSubmit={this.onSubmit}>
                    <fieldset>
                        <div className="input-plain">
                            <input type="text" name="traveler-firstname" className="form-control input-medium" placeholder="First Name" required onChange={(e) => this.updateValue('firstName', e.currentTarget.value)}/>
                        </div>
                        <div className="input-plain">
                            <input type="text" name="traveler-lastname" className="form-control input-medium" placeholder="Last Name" required onChange={(e) => this.updateValue('lastName', e.currentTarget.value)}/>
                        </div>
                        <div className="input-plain">
                            <input type="email" name="traveler-email" className="form-control input-medium" placeholder="Email" required onChange={(e) => this.updateValue('email', e.currentTarget.value)}/>
                        </div>
                        {this.renderRecaptcha()}
                    </fieldset>
                    <div className="submit-group">
                        {this.renderSubmit()}
                    </div>
                    <p className="modal-error help-block red"/>
                </form>
            </div>
        )
    }

    // Customizable Error and Success messages, just passing in success here
    modalSuccess() {
        return (
            <div className="modal-content">
                <h2>Invite Sent!</h2>
                <div>
                    An invite has been sent.
                </div>
                <button className="btn btn-medium btn-blue btn-submit" onClick={this.onModalHide}>Close</button>
            </div>
        )
    }

    onSubmit(e) {
        e.preventDefault()

        this.setState({isModalLoaderActive: true})
        let newTraveler = immutable.fromJS({
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            email: this.state.email,
            'g-recaptcha-response': this.state.recaptcha,
        })
        axios.post('/api/v1/trips/' + this.props.tripGuid + '/travelers/', newTraveler, {
            validateStatus: (function (status) {
                this.setState({isModalLoaderActive: false})
                return status < 500 // Reject only if the status code is greater than or equal to 500
            }).bind(this),
        }).then((function (response) {
            this.setState({isModalLoaderActive: false})
            if (response.status === 200 && response.data) {
                // We should have a traveler object, save it to json
                let newTravelerResponse = immutable.fromJS(response.data)
                this.props.onAddTravelers(newTravelerResponse)
                this.setState({statusModal: 'success'})
            } else {
                this.setState({statusModal: 'error'})
            }
        }).bind(this))
    }

    toggleFullTeam() {
        this.setState({showFullTeam: !this.state.showFullTeam})
    }

    render() {
        // TODO: We need to add guid or id to active traveler, for now comparing name, but obv. not ideal
        let userCount = 0
        let activeGuids = []
        let allRoles = []

        // Active travler also doesn't include role, so get al of them as name : role array
        this.props.travelers.map((traveler) => {
            let tVal = traveler.get('firstname') + ' ' + traveler.get('lastname')
            allRoles[tVal] = traveler.get('role')
        })

        // Style active travelers
        // HOW TO HANDLE LUNA USER?
        // maybe do a filter on active users to remove luna?
        let activeTravelers = this.props.activeUsers.map((traveler, index) => {
            activeGuids.push(traveler.get('name'))
            let tNameParts = traveler.get('name').split(' ')
            let fN = tNameParts[0] ? tNameParts[0].slice(0, 1) : ''
            let lN = tNameParts[1] ? tNameParts[1].slice(0, 1) : ''
            let tRole = allRoles[traveler.get('name')] ? allRoles[traveler.get('name')] : 'Not Set'
            userCount++
            return (
                <div key={index} className="user-icon active">
                    {fN}{lN}
                    <div className="user-info">
                        <h3>{traveler.get('name')}</h3>
                        <div>{tRole}</div>
                    </div>
                </div>
            )
        })

        // Remove active travelers from full traveler list
        let inactiveTravelers = this.props.travelers.filter((traveler) => activeGuids.indexOf(traveler.get('name')) === -1)

        // Style everybody who is left
        let inactiveTravelersObj = inactiveTravelers.map((traveler) => {
            userCount++
            return (
                <div key={traveler.get('guid')} className="user-icon inactive">
                    {traveler.get('firstname').slice(0, 1) + traveler.get('lastname').slice(0, 1)}
                    <div className="user-info">
                        <h3>{traveler.get('firstname') + ' ' + traveler.get('lastname')}</h3>
                        <div>{traveler.get('role')}</div>
                    </div>
                </div>
            )
        })

        let fullTeamBlock = this.props.travelers.map((traveler) => {
            return (
                <div key={traveler.get('guid')} className="team-block-item">
                    <div className="user-info">
                        <h3>{traveler.get('firstname') + ' ' + traveler.get('lastname')}</h3>
                        <div>{traveler.get('role')}</div>
                    </div>
                </div>
            )
        })

        let fullTeamClasses = classNames({'active': this.state.showFullTeam})

        let showMoreBtn = null
        if (userCount > 0 && !this.props.isLunaTrip) {
            if (userCount > 1) {
                showMoreBtn = <i className="show-more" onClick={this.toggleFullTeam}>...</i>
            }
            return (
                <div id="team-block">
                    <LunaModal statusModal={this.state.statusModal} onModalHide={this.onModalHide} showModal={this.state.showModal} modalContent={this.modalContent()}/>
                    <div id="team-block-wrapper">
                        <h2>TEAM</h2>
                        {activeTravelers}
                        {inactiveTravelersObj}
                        <div className="team-tools">
                            <i className="icon-plus" onClick={this.showModal}/>
                            {showMoreBtn}
                        </div>
                    </div>
                    <div id="team-block-full" className={fullTeamClasses}>
                        <i className="icon-close" onClick={this.toggleFullTeam}/>
                        {fullTeamBlock}
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
}


